export function validate(value) {
  return (
    typeof value?.name === 'string' &&
    /tx_card_field_definitions/.test(value.name)
  )
}
